// extracted by mini-css-extract-plugin
export var blue = "_1s-h";
export var brand = "_1s-d";
export var darkGrey = "_1s-g";
export var disabled = "_1s-6";
export var disabledSubtle = "_1s-7";
export var error = "_1s-8";
export var green = "_1s-i";
export var grey = "_1s-f";
export var icon = "_1s-0";
export var inherit = "_1s-c";
export var lightGrey = "_1s-e";
export var orange = "_1s-k";
export var pink = "_1s-m";
export var primary = "_1s-1";
export var purple = "_1s-n";
export var quaternary = "_1s-4";
export var quinary = "_1s-5";
export var red = "_1s-l";
export var secondary = "_1s-2";
export var success = "_1s-b";
export var tertiary = "_1s-3";
export var warning = "_1s-9";
export var warningSecondary = "_1s-a";
export var white = "_1s-o";
export var yellow = "_1s-j";